<div class="flex flex-col gap-4 p-4">
  <mat-form-field appearance="outline" class="w-full">
    <mat-label>Search leads</mat-label>
    <input
      matInput
      placeholder="Search by name, phone, or email"
      [formControl]="searchCtrl"
    />
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>

  <mat-progress-bar *ngIf="loading$ | async" mode="indeterminate" />

  @if ((hasResults$ | async) === false && (loading$ | async) === false) {
    @if (searchCtrl.value) {
      <pr-empty-state
        image="search"
        explicitTitle="No leads found"
        description="Try adjusting your search terms."
        [searchInputValue]="searchCtrl.value"
      />
    } @else {
      <pr-empty-state
        image="list"
        explicitTitle="No leads yet"
        description="Leads are automatically created when the AI receptionist receives calls from unrecognised numbers."
      />
    }
  }

  @if (hasResults$ | async) {
    <div class="mat-elevation-z1 bg-white">
      <mat-table [dataSource]="(leads$ | async) ?? []">
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef>Name</mat-header-cell>
          <mat-cell *matCellDef="let lead" class="truncate">
            <a [prBrandRouterLink]="['patients', lead.ref.id]">{{
              lead.name
            }}</a>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="phone">
          <mat-header-cell *matHeaderCellDef>Phone</mat-header-cell>
          <mat-cell *matCellDef="let lead" class="truncate">
            {{ lead.contactNumbers?.[0] ?? '—' }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="email">
          <mat-header-cell *matHeaderCellDef>Email</mat-header-cell>
          <mat-cell *matCellDef="let lead" class="truncate">
            {{ lead.email ?? '—' }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="created">
          <mat-header-cell *matHeaderCellDef>Created</mat-header-cell>
          <mat-cell *matCellDef="let lead">
            {{ lead.createdAt | moment | amDateFormat: dateTimeFormat }}
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns" />
        <mat-row *matRowDef="let row; columns: displayedColumns" />
      </mat-table>
    </div>
  }
</div>
